<template>
    <div>
        <OrderPayment v-on:update = "fetchData" />

        <el-table
                v-loading="loading"
                :data="data"
                style="width: 100%">

            <div slot="empty">
                <span v-if="!loading">{{ $t('el.table.emptyText') }}</span>
            </div>

            <el-table-column
                    prop="created_at"
                    :label="$t('created_at')">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i> {{ scope.row.created_at | moment("YYYY-MM-DD HH:mm") }}
                </template>
            </el-table-column>

            <el-table-column
                    prop="paid_at"
                    :label="$t('paid_at')">
                <template slot-scope="scope">
                    <span v-if="scope.row.paid_at"><i class="el-icon-time"></i> {{ scope.row.paid_at | moment("YYYY-MM-DD HH:mm") }}</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>

            <el-table-column
                    prop="amount"
                    :label="$t('amount')">
                <template slot-scope="scope">
                    {{ scope.row.amount | n(scope.row.amount_currency.fraction_digits, scope.row.amount_currency.symbol) }}
                </template>
            </el-table-column>

            <el-table-column
                    prop="payout"
                    :label="$t('disbursement')">
                <template slot-scope="scope">
                  {{ scope.row.payout | n(scope.row.payout_currency.fraction_digits, scope.row.payout_currency.symbol ) }}
                </template>
            </el-table-column>

            <el-table-column
                    :label="$t('payment_method')">
                <template slot-scope="scope" v-if="scope.row.method">
                    {{ scope.row.method.name }}
                </template>
            </el-table-column>

            <el-table-column
                    :label="$t('wallet')">
              <template slot-scope="scope">
                <el-popover
                    v-if="scope.row.wallet_data"
                    placement="left"
                    trigger="hover">
                  <div>
                    <div v-for="(w, k) in scope.row.wallet_data" :key="k" class="payment-info">
                      <div class="title">{{scope.row.method.schema[k] ? scope.row.method.schema[k].label: k}}</div>
                      <div class="desc">{{w}}</div>
                    </div>
                  </div>
                  <span slot="reference">
                    {{ Object.values(scope.row.wallet_data).join(', ') }}
                  </span>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column
                    prop="comment"
                    :label="$t('comment')">
              <template slot-scope="scope">
                <el-popover
                    v-if="scope.row.comment"
                    placement="left"
                    trigger="hover">
                  {{ scope.row.comment }}
                  <span slot="reference">
                    {{ scope.row.comment }}
                  </span>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column
                    prop="status"
                    :label="$t('status')">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.status === 1" disable-transitions>{{ $t('payment_statuses.paid') }}</el-tag>
                    <el-tag type="warning" v-if="scope.row.status === 0" disable-transitions>{{ $t('payment_statuses.awaiting') }}</el-tag>
                    <el-tag type="info" v-if="scope.row.status === -1" disable-transitions>{{ $t('payment_statuses.canceled') }}</el-tag>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-count="total_pages">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import OrderPayment from "../components/OrderPayment";
    export default {
        name: "Payment",
        components: {OrderPayment},
        data () {
            return {
                data: [],
                page: 1,
                total_pages: 0,
                loading: false,
            };
        },
        created () {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.loading = true;
                this.$axios.get('/payments?page=' + this.page).then((res) => {
                    this.loading = false;
                    this.data = res.data;
                    this.total_pages = parseInt(res.headers['x-pagination-page-count']);
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.fetchData()
            },
        }
    }
</script>

<style lang="scss" scoped>
.payment-info {
  margin-bottom: 5px;
  margin-top: 5px;
  .title {
    font-size: 13px;
    font-weight: bold;
    color: #909399;
  }
  .desc {
    font-size: 13px;
  }
}
</style>